
















import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import { RecomendationModule } from '@/app/store/modules/recomendation'
// import { BulletinModule } from '@/app/store/modules/bulletin'
// import { AdditionalModule } from '@/app/store/modules/additionalinfo'
// import { TrainingCategoryDataModule } from '@/app/store/modules/trainingCategory'
// import { GuideCategoryDataModule } from '@/app/store/modules/guideCategory'

@Component({
  name: 'Recomendation',
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
  },
})
export default class extends Vue {
  public created() {
    this.getRecomendation()
  }
  public getRecomendation() {
    RecomendationModule.getRecomendationData()
    // GuideCategoryDataModule.getGuideCategoryData()
    // TrainingCategoryDataModule.getTrainingCategoryData()
    // AdditionalModule.getAdditonalData()
    // BulletinModule.getBulletinData()
  }

  // public get trainingCategoryData() {
  //   return RecomendationModule.trainingCategoryData
  // }
  // public get guideCategoryData() {
  //   return RecomendationModule.guideCategoryData
  // }
  public get recomendationData() {
    return RecomendationModule.recomendationData
  }
  // public get additionalData() {
  //   return RecomendationModule.additionalData
  // }
  // public get bulletinData() {
  //   return RecomendationModule.bulletinData
  // }

  public get isLoading() {
    return RecomendationModule.isLoading
  }
  public fields: any = [
    { key: 'no', sortable: false },
    { key: 'type', sortable: false },
    { key: 'title', sortable: false },
    { key: 'recommended', sortable: false },
  ]
}
